import { call, put, select, takeLatest } from "redux-saga/effects";
import axios from "axios";
import qs from 'qs';
import iq_api_v2 from "../../../../services/iqApiV2";
import { FETCH_NEXT_STEPS_MP_CARD_REQUEST, fetchNextStepsMpCardFailure, fetchNextStepsMpCardSuccess } from "../../actions/meetingPrep/nextStepsMpCardActions";

async function findNextStepsMpData(opportunityId="") {
    const data = qs.stringify({
      opportunity_id: opportunityId,
    });
  
    // console.log("data",data)
    try {
      const response = await iq_api_v2.post("/opportunities/get_next_steps?"+data, '')
      return response?.data
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
    }

  }

// Worker Saga
function* fetchNextStepsMpSaga() {
  try {
    const payload = yield select(
      (state) => state?.nextStepsMpCardReducer?.payload
    );
    const { opportunityId=""} = payload;
    const data = yield call(
        findNextStepsMpData,
        opportunityId
    );
    yield put(fetchNextStepsMpCardSuccess(data?.[0]));
  } catch (error) {
    yield put(fetchNextStepsMpCardFailure(error.message));
  }
}

// Watcher Saga
export function* watchNextStepsMpData() {
  yield takeLatest(FETCH_NEXT_STEPS_MP_CARD_REQUEST, fetchNextStepsMpSaga);
}
